import { graphql } from "../../services/wp.api.service";

const query = `
mutation LoginGetMFACode($username: String!, $password: String) {
	loginGetMFA(input: { username: $username, password: $password }) {
		success
	}
}`

const loginMFACode = (useMutation) => useMutation(
	["loginMFACode"],
	({ username, password }) => graphql({
		query,
		variables: {
			password,
			username
		}
	})
);

export default loginMFACode;